import { Product } from '@interface/product';

export default class ProductService {
  static async getAllProducts({
    getAgendaProducts = false,
  }: {
    getAgendaProducts?: boolean;
  }): Promise<Product[]> {
    const urlApi = process.env.NEXT_PUBLIC_PRODUCTS_API;

    try {
      const url = getAgendaProducts
        ? `${urlApi}Product?getAgendaProducts=true`
        : `${urlApi}Product`;

      // Igual que getProduct: en servidor (producción) cacheamos con TTL para
      // que las páginas puedan ser estáticas/ISR; 'no-store' aquí obligaba a
      // renderizar dinámicamente toda ruta que listara productos.
      const isServer = typeof window === 'undefined';
      const requestInit: RequestInit =
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' && isServer
          ? { next: { revalidate: 3600 } }
          : { cache: 'no-store' };
      const res = await fetch(url, requestInit);
      if (res.ok) {
        const data = await res.json();
        return data;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  }
  static async getDashboardProducts(
    clinicId: string,
    getUpgrades = false
  ): Promise<Product[]> {
    try {
      let url = `${process.env.NEXT_PUBLIC_PRODUCTS_API}DashboardProducts?clinicId=${clinicId}`;
      url = getUpgrades ? url + '&getUpgrades=true' : url;
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        const products = data
          .map((product: Product) => ({
            ...product,
            visibility: true,
          }))
          .sort((a: any, b: any) => (a.price > b.price ? 1 : -1));

        return products;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  }

  static async getProduct(
    slug: string,
    isDashboard: boolean
  ): Promise<Product | undefined> {
    const apiUrl = process.env.NEXT_PUBLIC_PRODUCTS_API;

    try {
      const url = `${apiUrl}Product/${slug}?Dashboard=${isDashboard.toString()}`;

      // 'force-cache' guardaba el producto para siempre en dos sitios que un
      // deploy no invalida: el Data Cache de Next (persiste entre deploys) y
      // la caché HTTP del navegador (la API no manda Cache-Control). Por eso
      // las altas de clínica en un producto no llegaban a los usuarios
      // recurrentes. En servidor cacheamos con TTL, en cliente vamos a red.
      const isServer = typeof window === 'undefined';
      const requestInit: RequestInit =
        process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' && isServer
          ? { next: { revalidate: 3600 } }
          : { cache: 'no-store' };

      const res = await fetch(url, requestInit);

      if (res.ok) {
        const data = await res.json();
        return data;
      } else {
        return undefined;
      }
    } catch (err) {
      return undefined;
    }
  }
}
